import { MapObject } from "../../bookmydesk-api-sdk-typescript-axios";
import { kMaps } from "./maps";

export const kMapObjects: MapObject[] = [
  {
    id: "4fbe3261-8307-44fe-be5b-e1d0dd649070",
    mapId: kMaps[0].id,
    layer: "furniture",
    label: "",
    rotation: 90,
    x: 459,
    y: 88,
    typeName: "drawelement",
    subTypeName: "walkdirectionarrow",
  },
  {
    id: "6c6a2512-f994-4f30-9d5a-8072bd63ffa3",
    mapId: kMaps[0].id,
    layer: "furniture",
    label: "",
    rotation: 90,
    x: 393,
    y: 88,
    typeName: "drawelement",
    subTypeName: "walkdirectionarrow",
  },
  {
    id: "93d27686-d540-41d0-8640-39d19f409547",
    mapId: kMaps[0].id,
    layer: "furniture",
    label: "",
    rotation: 90,
    x: 614,
    y: 312,
    typeName: "drawelement",
    subTypeName: "walkdirectionarrow",
  },
  {
    id: "4fbe3261-8307-44fe-be5b-e1d0dd649071",
    mapId: kMaps[1].id,
    layer: "furniture",
    label: "",
    rotation: 90,
    x: 459,
    y: 88,
    typeName: "drawelement",
    subTypeName: "walkdirectionarrow",
  },
  {
    id: "6c6a2512-f994-4f30-9d5a-8072bd63ffa4",
    mapId: kMaps[1].id,
    layer: "furniture",
    label: "",
    rotation: 90,
    x: 393,
    y: 88,
    typeName: "drawelement",
    subTypeName: "walkdirectionarrow",
  },
  {
    id: "93d27686-d540-41d0-8640-39d19f409548",
    mapId: kMaps[1].id,
    layer: "furniture",
    label: "",
    rotation: 90,
    x: 614,
    y: 312,
    typeName: "drawelement",
    subTypeName: "walkdirectionarrow",
  },
];
